import React from "react";

interface WordSelectionOptionProps {
  wordOptions: string[];
  selectedWords: string[];
  draggedWord: string | null;
  setDraggedWord: (word: string | null) => void;
  setDraggedFromSentenceIdx: (idx: number | null) => void;
  setHoverIdx: (idx: number | null) => void;
  handleWordSelect: (word: string) => void;
  handleDragStartBank: (word: string) => void;
  handleDragOverBank: (e: React.DragEvent) => void;
  handleDropBank: () => void;
  checked?: boolean;
  correctAnswerIndo?: string[];
  darkMode?: boolean;
}

const WordSelectionOption: React.FC<WordSelectionOptionProps> = ({
  wordOptions,
  selectedWords,
  draggedWord,
  setDraggedWord,
  setDraggedFromSentenceIdx,
  setHoverIdx,
  handleWordSelect,
  handleDragStartBank,
  handleDragOverBank,
  handleDropBank,
  checked = false,
  correctAnswerIndo = [],
  darkMode = false,
}) => (
  <div className="w-full max-w-3xl mx-auto">
    <div
      className="flex flex-wrap gap-2 justify-center w-full mb-2 mt-4"
      onDragOver={handleDragOverBank}
      onDrop={handleDropBank}
    >
      {wordOptions.map((word, index) => {
        const isSelected = selectedWords.includes(word);

        // Highlight missing correct answers in option area
        let optionClass = darkMode
          ? "bg-gray-800 border-gray-600 text-gray-100"
          : "bg-white border-gray-300";
        if (checked && !isSelected && correctAnswerIndo.includes(word)) {
          optionClass = darkMode
            ? "bg-red-900 border-red-500 text-red-300"
            : "bg-red-100 border-red-500 text-red-700";
        }

        // Custom hover: keep red background if already red, else allow hover effect
        const hoverClass =
          checked && !isSelected && correctAnswerIndo.includes(word)
            ? darkMode
              ? "hover:bg-red-800"
              : "hover:bg-red-200"
            : darkMode
            ? "hover:bg-gray-700"
            : "hover:bg-gray-100";

        return isSelected ? (
          <div
            key={index}
            className={
              darkMode
                ? "px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-transparent select-none"
                : "px-4 py-2 bg-gray-200 border border-gray-300 rounded-lg text-transparent select-none"
            }
            style={{
              minWidth: "40px",
              minHeight: "40px",
              color: "transparent",
              userSelect: "none",
              pointerEvents: "none",
              fontFamily: "'DIN Next Rounded'",
            }}
          >
            {word}
          </div>
        ) : (
          <div
            key={index}
            draggable
            onDragStart={() => handleDragStartBank(word)}
            onDragEnd={() => {
              setHoverIdx(null);
              setDraggedWord(null);
              setDraggedFromSentenceIdx(null);
            }}
            className={`px-4 py-2 border rounded-lg cursor-grab duration-200 transform hover:-translate-y-0.5 transition-all ${optionClass} ${hoverClass}`}
            style={{
              minWidth: "40px",
              minHeight: "40px",
              whiteSpace: "nowrap",
              userSelect: "none",
              cursor: draggedWord ? "grabbing" : "grab",
              fontFamily: "'DIN Next Rounded'",
            }}
            tabIndex={0}
            role="button"
            onClick={() => handleWordSelect(word)}
          >
            {word}
          </div>
        );
      })}
    </div>
  </div>
);

export default WordSelectionOption;
